"use client";
import React, { useEffect } from "react";
import anime from "animejs"



const WaterDropGrid = () => {
    return (
        <div className="grid place-content-center py-0 bg-dark hidden md:flex">
            <DotGrid />
        </div>
    );
};


const gridHeight=20;
const gridWidth=19;


const DotGrid = () => {

    const handleDotClick = (e) => {
        anime({
          
            targets: ".dot-point",
            scale: [
              { value: 1.35, easing: "easeOutSine", duration: 250 },
              { value: 1, easing: "easeInOutQuad", duration: 500 },
            ],
            translateY: [
              { value: -15, easing: "easeOutSine", duration: 250 },
              { value: 0, easing: "easeInOutQuad", duration: 500 },
            ],
            opacity: [
              { value: 1, easing: "easeOutSine", duration: 250 },
              { value: 0.5, easing: "easeInOutQuad", duration: 500 },
            ],
            delay: anime.stagger(100, {
              grid: [gridWidth, gridHeight],
              from: e.target.dataset.index,
            }),
          });
    }

    // to trigger the animation once in the staarting
    useEffect(() => {
      const dot230 = document.querySelector(`[data-index="230"]`);
      if (dot230) {
        dot230.click();
      }
    }, []);


    const dots = [];
    let index = 0;

    for (let i = 0; i < gridWidth; i++) {
      for (let j = 0; j < gridHeight; j++) {
          dots.push(

              <div
              className="dot-point h-[1vh] w-[1vh] m-1 cursor-pointer rounded-full p-2  bg-gradient-to-b from-slate-700 to-slate-400 opacity-50 hover:from-red-600 hover:to-pink-500 hover:scale-150"
              data-index={index}
              />
    
          );
          index++;
    }
  }

  return (
    <div
      onClick={handleDotClick}
      style={{ gridTemplateColumns: `repeat(${gridWidth}, 1fr)` }}
      className="grid w-fit"
    >
      {dots}
    </div>
  );
};

export default WaterDropGrid;